<div class="contact-us-content">
<div class="form-name">
  <h3>{{ languageService.translate(['CONTACT US', 'СВЯЗАТЬСЯ С НАМИ']) }}</h3>
</div>
  <form
    class="contact-form__wrapper"
    (ngSubmit)="onSubmit()"
    #contactForm="ngForm"
  >

    <div class="contact-form">
      <div class="two-columns">
        <label class="tt-form-label">
          <span class="tt-form-label__text">{{ languageService.translate(['FULL NAME', 'ПОЛНОЕ ИМЯ']) }}</span>
          <input
            type="text"
            class="tt-form-input"
            [(ngModel)]="fullName"
            name="fullName"
            required
          >
        </label>

        <label class="tt-form-label">
         <span class="tt-form-label__text">{{ languageService.translate(['COMPANY', 'КОМПАНИЯ']) }}</span>
          <input
            type="text"
            class="tt-form-input"
            [(ngModel)]="company"
            name="company"
            required
          >
        </label>
      </div>
    </div>

    <div class="contact-form">
      <div class="two-columns">
        <label class="tt-form-label">
         <span class="tt-form-label__text">{{ languageService.translate(['PHONE NUMBER', 'НОМЕР ТЕЛЕФОНА']) }}</span>
          <input
            type="tel"
            class="tt-form-input"
            [(ngModel)]="phoneNumber"
            name="phoneNumber"
            (input)="formatPhoneNumber($event)"
            [class.invalid]="phoneError"
            placeholder="+1 (000) 000-0000"
            required
          >
          <span class="error-message" *ngIf="phoneError">{{ getPhoneErrorText() }}</span>
        </label>

        <label class="tt-form-label">
          <span class="tt-form-label__text">{{ languageService.translate(['EMAIL', 'EMAIL']) }}</span>
          <input
            type="email"
            class="tt-form-input"
            [(ngModel)]="email"
            name="email"
            (input)="validateEmail($event)"
            [class.invalid]="emailError"
            placeholder="example@domain.com"
            required
          >
          <span class="error-message" *ngIf="emailError">{{ getEmailErrorText() }}</span>
        </label>
      </div>
    </div>

    <div class="contact-form">
      <label class="tt-form-label">
       <span class="tt-form-label__text">{{ languageService.translate(['SUBJECT OF THE REQUEST', 'ТЕМА ЗАПРОСА']) }}</span>
        <app-select-dropdown
          [options]="hearAboutOptions"
          [placeholder]="languageService.translate(['Select an option', 'Выберите вариант'])"
          [(value)]="selectedHearAbout"
          (selectionChange)="onHearAboutChange($event)"
        >
        </app-select-dropdown>
      </label>
    </div>

    <div class="contact-form">
      <label class="tt-form-label">
        <span class="tt-form-label__text">{{ languageService.translate(['MESSAGE', 'СООБЩЕНИЕ']) }}</span>
        <textarea
          class="tt-form-textarea"
          rows="5"
          [(ngModel)]="message"
          name="message"
          [placeholder]="languageService.translate(['Type your message here...','Введите сообщение здесь...'])"
          (input)="autoResize($event)"
          required
        ></textarea>
      </label>
    </div>

    <div class="contact-form checkbox-field">
      <label class="standard-checkbox-label">
        <input
          type="checkbox"
          [(ngModel)]="isConsentGiven"
          name="consent"
          class="standard-checkbox"
          required
          style="border-radius: 6px;"
        >
        <span class="checkbox-text">
          {{ languageService.translate(['I have read the', 'Я ознакомился с']) }}<a href="#" class="terms-link">
          {{ languageService.translate(['terms of the privacy policy', 'условиями политики конфиденциальности']) }}
          </a>
          {{ languageService.translate(['and consent to the processing of personal data', 'и даю согласие на обработку персональных данных']) }}
        </span>
      </label>
    </div>

    <div class="button-container">
      <button
        type="submit"
        class="submit-btn"
        [disabled]="!isFormValid()"
      >
        {{ languageService.translate(['Make request', 'Отправить запрос']) }}
      </button>
    </div>

  </form>
</div>
